import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ca2db02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-switch-container" }
const _hoisted_2 = {
  key: 1,
  class: "progress-bar-container"
}
const _hoisted_3 = { class: "switch-page" }
const _hoisted_4 = { class: "switch-page" }
const _hoisted_5 = { class: "switch-page" }
const _hoisted_6 = { class: "switch-page" }
const _hoisted_7 = { class: "switch-page" }
const _hoisted_8 = { class: "switch-page" }
const _hoisted_9 = { class: "switch-page" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "switch-page" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "confirmation-page" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "confirmation-page-title" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "tick-icon" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" })
      ]),
      /*#__PURE__*/_createElementVNode("h6", null, "THANKS FOR SUBMITTING THE SWITCH INFORMATION.")
    ]),
    /*#__PURE__*/_createElementVNode("span", null, "What happens next?"),
    /*#__PURE__*/_createElementVNode("p", null, " The Tenant will receive SMS and email communication from Property Button shortly with details of how they can log into the Property Button platform to order their energy and media products. ")
  ])
], -1))
const _hoisted_11 = { class: "tenant-switch-footer-container" }
const _hoisted_12 = { class: "steps" }
const _hoisted_13 = { class: "right-hand-buttons" }
const _hoisted_14 = { class: "right-button" }

import { baseAlert } from "@/alerts/baseAlert";
import DocumentUpload from "@/components/file-uploader/document-upload.vue";
import { Address } from "@/types/generic/Address";
import { EnergyDetails } from "@/types/switches/EnergyDetails";
import { LandlordPersonalInfo } from "@/types/switches/LandlordPersonalInfo";
import { MprnLookupResponse } from "@/types/switches/MprnLookupResponse";
import { PersonalInfo } from "@/types/switches/PersonalInfo";
import { TenantSwitchConsent } from "@/types/switches/TenantSwitchConsent";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import { QuestionsWizardData } from "@/types/wizard/question-wizard-data";
import { CountryCode } from "bright-logic-core/src/CountryCode";
import { DxButton } from "devextreme-vue";
import DxMultiView from "devextreme-vue/multi-view";
import { ValidatedEvent } from "devextreme/ui/validator";
import { computed, ref, watch, inject } from "vue";
import ModalBase from "../../ui/modals/modal-base.vue";
import ConsentPage from "../consent-page.vue";
import EnergyDetailsPage from "../energy-details-page.vue";
import SummaryPage from "../summary-page.vue";
import TenantDetailsPage from "./tenant-details-page.vue";
import TenantSwitchProgress from "../tenant-switch-progress.vue";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { TenantSwitchSubmitData } from "@/types/utility-switching/TenantSwitchSubmitData";
import { SubmissionResponse } from "@/types/utility-switching/SubmissionResponse";
import { CollateTenantSubmissionData } from "@/utils/utility-switching/CollateSwitchSubmissionData";
import { EnergyTypes } from "@/enums/utility-switching/EnergyTypes";
import { AddressEnergyTypeMapper } from "@/utils/utility-switching/AddressEnergyTypeMapper";
import { Properties } from "acquaint-api/models/Properties";
import { FindEnergyTypeText } from "@/utils/utility-switching/FindEnergyTypeText";
import PropertyOwnerDetailsPage from "../property-owner-details-page.vue";
import PropertyLookupPage from "../property-lookup-page.vue";
import { SupportCaseDocumentType } from "@/enums/utility-switching/SupportCaseDocumentType";
import { standardInfoAlert } from "@/alerts/standardInfoAlert";
import { GasMeterTypes } from "@/enums/utility-switching/GasMeterTypes";
import { TenantSwitchStep } from "@/enums/utility-switching/TenantSwitchStep";
import { getDefaultAddressValue } from "@/utils/address/AddressFormatter";
import { SwitchPage } from "@/enums/utility-switching/SwitchPage";
import { getDefaultEnergyDetailsModel } from "@/utils/utility-switching/EnergyDetailsMapper";
import displayErrorMessage from "@/utils/ErrorHandling";
import { Contacts } from "acquaint-api/models/Contacts";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { Tenancies } from "acquaint-api/models/Tenancies";
import TcfMessage from "./tcf-message.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'tenant-switching-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The unique identifier for the property.
   * @type {number}
   * @default -1
   */
  propertyId: {
    type: Number,
    default: -1,
  },
  /**
   * The unique identifier for the contact.
   * @type {number}
   * @default -1
   */
  contactId: {
    type: Number,
    default: -1,
  },
  /**
   * The unique identifier for the tenancy.
   * @type {number}
   * @default -1
   */
  tenancyId: {
    type: Number,
    default: -1,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes.
   * This is used to update the v-model variable in the parent component and control the visibility of the modal.
   * @event update:modelValue
   * @property {boolean} value - The updated state to reflect whether the modal should be shown or hidden.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const showPopup = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

// If user comes to the app from Desktop Acquaint and are taken immediately to this wizard,
// we must auto-fill the tenant info using the contact they selected in Desktop
const fetchTenantInformation = async () => {
  try {
    tenantApiInfo.value = await apiClient.httpGet<Contacts>(
      `database/contacts/${props.contactId}`,
    );
  } catch (ex) {
    displayErrorMessage(getErrorMessage(ex));
    tenantApiInfo.value = undefined;
  }
};

const fetchTenancyInformation = async () => {
  try {
    tenancyInformation.value = await apiClient.httpGet<Tenancies>(
      `database/tenancies/${props.tenancyId}`,
    );
  } catch (ex) {
    displayErrorMessage(getErrorMessage(ex));
    tenancyInformation.value = undefined;
  }
};

const autoFillFields = async () => {
  if (props.contactId > 0) {
    await fetchTenantInformation();
  }

  if (props.tenancyId > 0) {
    await fetchTenancyInformation();
  }

  if (tenantApiInfo.value) {
    tenantPersonalInfo.value.id = props.contactId;
    tenantPersonalInfo.value.title = tenantApiInfo.value.titleID;
    tenantPersonalInfo.value.firstName = tenantApiInfo.value.firstNames;
    tenantPersonalInfo.value.lastName = tenantApiInfo.value.lastName;
    tenantPersonalInfo.value.number = tenantApiInfo.value.mobileTelephone;
    tenantPersonalInfo.value.email = tenantApiInfo.value.email;
    tenantPersonalInfo.value.birthDate = tenantApiInfo.value.birthDate;
  }

  if (tenancyInformation.value) {
    tenantPersonalInfo.value.tenancyStartDate =
      tenancyInformation.value.startDate;
  }
};

watch(
  () => showPopup.value,
  () => {
    if (!showPopup.value) {
      return;
    }

    autoFillFields();
  },
);

const tenantApiInfo = ref<Contacts>();
const tenancyInformation = ref<Tenancies>();
const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;

const disableSummaryEditButtons = ref(false);

// Each page must be assigned a template name for it to appear
const pages = ref<QuestionsWizardData[]>([
  {
    template: "property",
  },
  {
    template: "energy",
  },
  {
    template: "tenant",
  },
  {
    template: "landlord",
  },
  {
    template: "tcf",
  },
  {
    template: "consent",
  },
  {
    template: "switch-summary",
  },
  {
    template: "confirmation",
  },
]);

const nextSubmitButtonText = computed(() => {
  switch (selectedIndex.value) {
    case TenantSwitchStep.Summary:
      return "Submit";
    case TenantSwitchStep.Confirmation:
      return "Done";
    default:
      return "Next";
  }
});

const selectedIndex = ref(0);

// This assigns the next button its validation group so that it can calidate the right group of of input fields
// e.g. the inputs are within the group 'propertyGroup' and they need to be validated before the user can go onto
// the next page
const buttonValidationGroup = computed(() => {
  switch (selectedIndex.value) {
    case TenantSwitchStep.PropertyLookup:
      return "propertyGroup";
    case TenantSwitchStep.Energy:
      return "energy";
    case TenantSwitchStep.Tenant:
      return "tenant";
    case TenantSwitchStep.Landlord:
      return "landlord";
    case TenantSwitchStep.Consent:
      return "consent";
    default:
      return "";
  }
});

const submissionRepsonse = ref<SubmissionResponse>();
const tcfUploadFailed = ref(false);

const submitSwitchDetails = async () => {
  // We must disable the summary edit buttons and the nav buttons to prevent users from making changes while the api submission call is being made
  disableSummaryEditButtons.value = true;
  nextButtonLocked.value = true;
  backButtonDisabled.value = true;

  let submitData: TenantSwitchSubmitData = CollateTenantSubmissionData(
    propertyAddress.value,
    energyDetails.value,
    energyType.value,
    switchPropertyId.value,
    tenantPersonalInfo.value,
    landlordPersonalInfo.value,
    props.tenancyId,
  );

  try {
    submissionRepsonse.value = await apiClient.httpPost<SubmissionResponse>(
      "app/utilityswitching/switches/tenant",
      submitData,
    );
  } catch (err) {
    displayErrorMessage("We cannot submit your switch");
  }

  // If a tcf file has been added, we will upload it and check if it's successful, otherwise there's no point calling the tcf API
  if (submissionRepsonse.value?.caseID && tcf.value && tcf.value.length > 0) {
    await uploadDocument(SupportCaseDocumentType.Tcf, tcf.value[0]);
    checkTcfUpload();
  } else if (
    submissionRepsonse.value?.caseID &&
    (!tcf.value || tcf.value.length == 0)
  ) {
    selectedIndex.value = selectedIndex.value + 1;
    stageEight.value = 1;
  }

  if (submissionRepsonse.value?.caseID) {
    showCloseConfirmationPrompt.value = false;
  }

  // We must reset these to ensure that the summary edit buttons and the nav buttons are enabled if a user submits a switch and then starts a new one
  // or if the submission fails
  disableSummaryEditButtons.value = false;
  nextButtonLocked.value = false;
  backButtonDisabled.value = false;
  tcfUploadFailed.value = false;
};

const checkTcfUpload = () => {
  if (tcfUploadFailed.value) {
    standardInfoAlert(
      "Your switch was successfully submitted but your TCF was unsuccessfully submitted, please contact support.",
    ).then((result) => {
      if (result.isConfirmed) {
        selectedIndex.value = selectedIndex.value + 1;
        stageEight.value = 1;
        nextButtonLocked.value = false;
        backButtonDisabled.value = false;
      }
    });
  } else {
    selectedIndex.value = selectedIndex.value + 1;
    stageEight.value = 1;
    nextButtonLocked.value = false;
    backButtonDisabled.value = false;
  }
};

const uploadDocument = async (
  documentType: SupportCaseDocumentType,
  document: File,
) => {
  try {
    await apiClient.uploadFile(
      `app/utilityswitching/supportcases/documents/${submissionRepsonse.value?.caseID}/${documentType}`,
      document,
    );
  } catch (err) {
    tcfUploadFailed.value = true;
  }
};

const navigate = async (navigateDirection: number, e: any) => {
  if (navigateDirection > 0) {
    // We must close the alert on the enrgy page if it is open and prevent any validation from occurring, as the app will otherise
    // err, and prevent the user from progressing forwards
    if (baseAlert.isVisible()) {
      baseAlert.close();
      return;
    }

    const validation: ValidatedEvent = e.validationGroup.validate();

    // Don't continue if user has entered invalid data
    if (!validation.isValid) {
      return;
    }

    if (
      selectedIndex.value == TenantSwitchStep.Tenant &&
      !tenantTelephoneNumberValid.value
    ) {
      displayErrorMessage("Please enter a valid telephone number.");
      return;
    }

    if (
      selectedIndex.value == TenantSwitchStep.Landlord &&
      !landlordTelephoneNumberValid.value
    ) {
      displayErrorMessage("Please enter a valid telephone number.");
      return;
    }

    // Force users to select whether the property has a pay as you go meter
    if (
      selectedIndex.value === TenantSwitchStep.Energy &&
      !payAsYouGoSelected.value &&
      energyType.value != EnergyTypes.ElectricityOnly
    ) {
      displayErrorMessage(
        "Please select whether the property has a Pay as you go Meter",
      );
      return;
    }

    // If the user is moving forwards, the progress bars must have their values updated to 1 (a value of 1 makes a progress bar fill in)
    switch (selectedIndex.value) {
      case TenantSwitchStep.PropertyLookup:
        stageTwo.value = 1;
        break;
      case TenantSwitchStep.Energy:
        stageThree.value = 1;
        break;
      case TenantSwitchStep.Tenant:
        stageFour.value = 1;
        break;
      case TenantSwitchStep.Landlord:
        stageFive.value = 1;
        break;
      case TenantSwitchStep.Tcf:
        stageSix.value = 1;
        break;
      case TenantSwitchStep.Consent:
        stageSeven.value = 1;
        break;
    }
  }

  if (
    selectedIndex.value == TenantSwitchStep.Summary &&
    navigateDirection > 0
  ) {
    await submitSwitchDetails();
    return;
  }

  if (
    selectedIndex.value == TenantSwitchStep.Confirmation &&
    navigateDirection > 0
  ) {
    closeModal();
  }

  selectedIndex.value = selectedIndex.value + navigateDirection;

  // If the user is moving backwards, the progress bars must have their values updated to 0 (a value of 0 makes a progress bar empty itself)
  if (navigateDirection < 0) {
    if (baseAlert.isVisible()) {
      baseAlert.close();
    }

    switch (selectedIndex.value) {
      case TenantSwitchStep.PropertyLookup:
        stageTwo.value = 0;
        break;
      case TenantSwitchStep.Energy:
        stageThree.value = 0;
        break;
      case TenantSwitchStep.Tenant:
        stageFour.value = 0;
        break;
      case TenantSwitchStep.Landlord:
        stageFive.value = 0;
        break;
      case TenantSwitchStep.Tcf:
        stageSix.value = 0;
        break;
      case TenantSwitchStep.Consent:
        stageSeven.value = 0;
        break;
    }
  }
};

// When closing the modal, we must reset each progress bar
const closeModal = () => {
  nextButtonLocked.value = false;
  backButtonDisabled.value = false;
  showCloseConfirmationPrompt.value = false;
  showPopup.value = false;
  if (baseAlert.isVisible()) {
    baseAlert.close();
  }
};

const resetToDefaultState = () => {
  // We must reset this to ensure that the summary edit/nav buttons are enabled if a user submits a switch and then starts a new one
  disableSummaryEditButtons.value = false;
  nextButtonLocked.value = false;
  backButtonDisabled.value = false;

  //All values must be reset when the modal closes
  selectedIndex.value = TenantSwitchStep.PropertyLookup;
  stageTwo.value = 0;
  stageThree.value = 0;
  stageFour.value = 0;
  stageFive.value = 0;
  stageSix.value = 0;
  stageSeven.value = 0;
  stageEight.value = 0;

  dateRegulationsConsent.value = {
    personalDataComplient: false,
    receiveCommunication: false,
  };

  // Need to clone the empty address, to avoid the addresses using the same variable in memory
  propertyAddress.value = {
    countryCode: CountryCode.Ireland,
    postCode: "",
    propertyName: "",
    street: "",
    locality: "",
    town: "",
    region: "",
    country: "Ireland",
  };

  tenantPersonalInfo.value = {
    id: 0,
    title: 0,
    firstName: "",
    lastName: "",
    number: "",
    email: "",
    tenancyStartDate: "",
    priorityService: false,
    birthDate: "",
  };

  landlordPersonalInfo.value = {
    id: 0,
    title: 0,
    firstName: "",
    lastName: "",
    number: "",
    address: {
      countryCode: CountryCode.Ireland,
      postCode: "",
      propertyName: "",
      street: "",
      locality: "",
      town: "",
      region: "",
      country: "Ireland",
    },
  };

  energyDetails.value = getDefaultEnergyDetailsModel();

  payAsYouGoSelected.value = false;
  showCloseConfirmationPrompt.value = true;
  tcfUploadFailed.value = false;
  tcf.value = undefined;
};

// These are the progress bar statuses, if a bar's status is 0, the bar is has no progress and
// when it is 1, the bar has been 100% completed.
const stageTwo = ref(0);
const stageThree = ref(0);
const stageFour = ref(0);
const stageFive = ref(0);
const stageSix = ref(0);
const stageSeven = ref(0);
const stageEight = ref(0);

//selectedIndex starts at 0 so we have to add 1 to it when displaying the stage to the user
const switchStage = ref(1);

// When we get to the energy page, the next page needs to be disabled (to prevent users from not searching for an MPRN number)
// and the appropriate progress bars needs to be reset when users return to previous pages from the summary page (only four
// pages can be accessed from the summary page)
watch(
  () => selectedIndex.value,
  () => {
    switchStage.value = selectedIndex.value + 1;

    switch (selectedIndex.value) {
      case TenantSwitchStep.PropertyLookup: {
        nextButtonLocked.value = false;
        stageTwo.value = 0;
        stageThree.value = 0;
        stageFour.value = 0;
        stageFive.value = 0;
        stageSix.value = 0;
        stageSeven.value = 0;
        stageEight.value = 0;
        break;
      }
      case TenantSwitchStep.Energy: {
        /* Ensure user has performed the mprn lookup. Otherwise they can skip an important step/process
         * which could cause liability implications for PB */
        if (mprnAddressEmpty.value) {
          nextButtonLocked.value = true;
        }
        stageThree.value = 0;
        stageFour.value = 0;
        stageFive.value = 0;
        stageSix.value = 0;
        stageSeven.value = 0;
        stageEight.value = 0;
        break;
      }
      case TenantSwitchStep.Tenant: {
        stageFour.value = 0;
        stageFive.value = 0;
        stageSix.value = 0;
        stageSeven.value = 0;
        stageEight.value = 0;
        break;
      }
      case TenantSwitchStep.Landlord: {
        stageFive.value = 0;
        stageSix.value = 0;
        stageSeven.value = 0;
        stageEight.value = 0;
        break;
      }
    }
  },
);

/** Checks whether the mprn address is empty */
const mprnAddressEmpty = computed(() => {
  return [
    mprnAddress.value.propertyName,
    mprnAddress.value.street,
    mprnAddress.value.locality,
    mprnAddress.value.town,
    mprnAddress.value.region,
  ].every((item) => !item);
});

const propertyAddress = ref<Address>({
  countryCode: CountryCode.Ireland,
  postCode: "",
  propertyName: "",
  street: "",
  locality: "",
  town: "",
  region: "",
  country: "",
});

const tenantPersonalInfo = ref<PersonalInfo>({
  id: 0,
  title: 0,
  firstName: "",
  lastName: "",
  number: "",
  email: "",
  tenancyStartDate: "",
  priorityService: false,
  birthDate: "",
});

const landlordPersonalInfo = ref<LandlordPersonalInfo>({
  id: 0,
  title: 0,
  firstName: "",
  lastName: "",
  number: "",
  address: {
    countryCode: CountryCode.Ireland,
    postCode: "",
    propertyName: "",
    street: "",
    locality: "",
    town: "",
    region: "",
    country: "",
  },
});

const energyDetails = ref<EnergyDetails>({
  nightSaverMeterRead: "",
  twentyfourHMeterRead: "",
  gasGPRNNum: "",
  gasMeterRead: "",
  readingDate: "",
  payAsYouGo: false,
  energyType: "Electricity Only",
  nightMeterRead: "",
  peakMeterRead: "",
  dayMeterMeterRead: "",
  mprn: "",
  electricMeterType: 0,
});

const dateRegulationsConsent = ref<TenantSwitchConsent>({
  personalDataComplient: false,
  receiveCommunication: false,
});

const mprnAddress = ref<Address>({
  countryCode: 0,
  postCode: "",
  propertyName: "",
  street: "",
  locality: "",
  town: "",
  region: "",
  country: "",
});

// This ref confirms whether or not a the address found by the MPRN has been confirmed to be the correct one
// on the energy page.
const addressValidated = ref(true);

const nextButtonLocked = ref(false);
const backButtonDisabled = ref(false);

/* This is triggered by the user answering the address confirmation modal (i.e. the user
 * has confirmed the address found by the MPRN lookup does not match the previously entered address)
 * or by the MPRN address matching the entered address. For example, if both addresses match,
 * the next button is unlocked. This is true for when the user confirm the address using the popup.
 * Otherwise, the button remains unlocked.
 * This is also triggered when users lookup an MpRN number and then change it
 * without looking it up again - the next button remains unlocked until they do */
const disableNextButton = (
  inValid: boolean,
  selectedProperty: MprnLookupResponse,
) => {
  if (selectedIndex.value != TenantSwitchStep.Energy) {
    return;
  }

  nextButtonLocked.value = inValid;

  if (selectedProperty) {
    mprnAddress.value.propertyName = selectedProperty.addressPropertyName;
    mprnAddress.value.street = selectedProperty.addressStreet;
    mprnAddress.value.locality = selectedProperty.addressLocality;
    mprnAddress.value.town = selectedProperty.addressTown;
    mprnAddress.value.region = selectedProperty.addressRegion;
    mprnAddress.value.postCode = selectedProperty.addressPostcode;
  } else {
    mprnAddress.value = getDefaultAddressValue();
  }
};

const tcf = ref<File[]>();

/** Handles the TCF Changed event of the Document upload component */
const onTcfChanged = (e: File[]) => {
  tcf.value = e;
};

const payAsYouGoSelected = ref(false);
const onPayAsYouGoSelected = () => (payAsYouGoSelected.value = true);

const energyType = ref(EnergyTypes.ElectricityOnly);
const switchPropertyId = ref(0);
const gasMeterType = ref(-1);

const resetEnergyFields = () => {
  gasMeterType.value = -1;
  switchPropertyId.value = 0;
  payAsYouGoSelected.value = false;
  energyDetails.value = getDefaultEnergyDetailsModel();
};

// The correct energy type option on the energy page is pre-selected when the user selects a property from the seacrh dropdown
const propertySelected = (selectedProperty: Properties) => {
  resetEnergyFields();

  if (!selectedProperty) {
    return;
  }

  energyType.value = AddressEnergyTypeMapper(
    selectedProperty.gas,
    selectedProperty.electric,
  );
  energyDetails.value.energyType = FindEnergyTypeText(energyType.value);
  energyDetails.value.mprn = selectedProperty.utilitySupplierElectricityRef;
  energyDetails.value.gasGPRNNum = selectedProperty.utilitySupplierGasRef;
  landlordPersonalInfo.value.id = selectedProperty.contactID;
  switchPropertyId.value = selectedProperty.id;

  if (
    selectedProperty.gasMeterType == GasMeterTypes.payg ||
    selectedProperty.gasMeterType == GasMeterTypes.standard ||
    selectedProperty.gasMeterType == GasMeterTypes.smart
  ) {
    gasMeterType.value = selectedProperty.gasMeterType;
    payAsYouGoSelected.value = true;
  }

  // As the property has been changed, the previous mprn address is no longer valid
  mprnAddress.value = getDefaultAddressValue();
};

const showCloseConfirmationPrompt = ref(true);

const onModalClosed = () => {
  resetToDefaultState();

  // Ensure all fields are reset by incrementing the content key
  contentRenderKey.value++;
};

const contentRenderKey = ref(0);
const tenantTelephoneNumberValid = ref(false);
const landlordTelephoneNumberValid = ref(false);

const newSwitchOver = () => {
  closeModal();
  setTimeout(() => {
    showPopup.value = true;
  }, 300);
};

const tcfUploaded = computed(() => {
  return !tcf.value || tcf.value.length == 0;
});

const updatePageNumber = (changeToPage: string) => {
  switch (changeToPage) {
    case SwitchPage.PropertyPage:
      selectedIndex.value = TenantSwitchStep.PropertyLookup;
      break;
    case SwitchPage.EnergyPage:
      selectedIndex.value = TenantSwitchStep.Energy;
      break;
    case SwitchPage.TenantPage:
      selectedIndex.value = TenantSwitchStep.Tenant;
      break;
    case SwitchPage.LandlordPage:
      selectedIndex.value = TenantSwitchStep.Landlord;
      break;
    case SwitchPage.TcfPage:
      selectedIndex.value = TenantSwitchStep.Tcf;
      break;
  }
};

const screenWidth = ref(screen.width);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showPopup.value,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((showPopup).value = $event)),
    showCloseButton: true,
    title: "New Tenant Switch",
    height: "80vh",
    width: _unref(ModalWidth).Medium,
    "show-close-confirmation-prompt": showCloseConfirmationPrompt.value,
    onModalClosed: onModalClosed,
    key: contentRenderKey.value
  }, {
    "non-scrollable-content": _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        (screenWidth.value < 768)
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              class: _normalizeClass(["progress-bar-container", { smallScreensProgressContainer: screenWidth.value < 768 }])
            }, [
              _createElementVNode("div", null, [
                _createVNode(TenantSwitchProgress, {
                  index: selectedIndex.value,
                  title: "Property",
                  number: 1,
                  progress: stageTwo.value
                }, null, 8, ["index", "progress"]),
                _createVNode(TenantSwitchProgress, {
                  index: selectedIndex.value,
                  title: "Energy",
                  number: 2,
                  progress: stageThree.value
                }, null, 8, ["index", "progress"]),
                _createVNode(TenantSwitchProgress, {
                  index: selectedIndex.value,
                  title: "Tenant",
                  number: 3,
                  progress: stageFour.value
                }, null, 8, ["index", "progress"]),
                _createVNode(TenantSwitchProgress, {
                  index: selectedIndex.value,
                  title: "Landlord",
                  number: 4,
                  progress: stageFive.value
                }, null, 8, ["index", "progress"]),
                _createVNode(TenantSwitchProgress, {
                  index: selectedIndex.value,
                  title: "TCF",
                  number: 5,
                  progress: stageSix.value
                }, null, 8, ["index", "progress"]),
                _createVNode(TenantSwitchProgress, {
                  index: selectedIndex.value,
                  title: "Consent",
                  number: 6,
                  progress: stageSeven.value
                }, null, 8, ["index", "progress"])
              ]),
              _createElementVNode("div", null, [
                _createVNode(TenantSwitchProgress, {
                  index: selectedIndex.value,
                  title: "Summary",
                  number: 7,
                  progress: stageEight.value
                }, null, 8, ["index", "progress"]),
                _createVNode(TenantSwitchProgress, {
                  index: selectedIndex.value,
                  title: "Confirmation",
                  number: 8,
                  progress: -1
                }, null, 8, ["index"])
              ])
            ], 2))
          : _createCommentVNode("", true),
        (screenWidth.value >= 768)
          ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
              _createVNode(TenantSwitchProgress, {
                index: selectedIndex.value,
                title: "Property",
                number: 1,
                progress: stageTwo.value
              }, null, 8, ["index", "progress"]),
              _createVNode(TenantSwitchProgress, {
                index: selectedIndex.value,
                title: "Energy",
                number: 2,
                progress: stageThree.value
              }, null, 8, ["index", "progress"]),
              _createVNode(TenantSwitchProgress, {
                index: selectedIndex.value,
                title: "Tenant",
                number: 3,
                progress: stageFour.value
              }, null, 8, ["index", "progress"]),
              _createVNode(TenantSwitchProgress, {
                index: selectedIndex.value,
                title: "Landlord",
                number: 4,
                progress: stageFive.value
              }, null, 8, ["index", "progress"]),
              _createVNode(TenantSwitchProgress, {
                index: selectedIndex.value,
                title: "TCF",
                number: 5,
                progress: stageSix.value
              }, null, 8, ["index", "progress"]),
              _createVNode(TenantSwitchProgress, {
                index: selectedIndex.value,
                title: "Consent",
                number: 6,
                progress: stageSeven.value
              }, null, 8, ["index", "progress"]),
              _createVNode(TenantSwitchProgress, {
                index: selectedIndex.value,
                title: "Summary",
                number: 7,
                progress: stageEight.value
              }, null, 8, ["index", "progress"]),
              _createVNode(TenantSwitchProgress, {
                index: selectedIndex.value,
                title: "Confirmation",
                number: 8,
                progress: -1
              }, null, 8, ["index"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_unref(DxMultiView), {
          height: "calc(100% - 40px)",
          width: "100%",
          "selected-index": selectedIndex.value,
          "onUpdate:selectedIndex": _cache[9] || (_cache[9] = ($event: any) => ((selectedIndex).value = $event)),
          loop: false,
          "animation-enabled": true,
          "data-source": pages.value,
          "swipe-enabled": false
        }, {
          property: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(PropertyLookupPage, {
                modelValue: propertyAddress.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((propertyAddress).value = $event)),
                validationGroup: "propertyGroup",
                propertyId: props.propertyId,
                onPropertySelected: propertySelected,
                onChoseNotToUseExistingProperty: resetEnergyFields
              }, null, 8, ["modelValue", "propertyId"])
            ])
          ]),
          energy: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(EnergyDetailsPage, {
                energy: energyDetails.value,
                "onUpdate:energy": _cache[1] || (_cache[1] = ($event: any) => ((energyDetails).value = $event)),
                address: propertyAddress.value,
                "address-validated": addressValidated.value,
                "onUpdate:addressValidated": _cache[2] || (_cache[2] = ($event: any) => ((addressValidated).value = $event)),
                validationGroup: "energy",
                "energy-type": energyType.value,
                "onUpdate:energyType": _cache[3] || (_cache[3] = ($event: any) => ((energyType).value = $event)),
                onDisableNextButton: disableNextButton,
                onPayAsYouGoSelected: onPayAsYouGoSelected,
                gasMeterType: gasMeterType.value
              }, null, 8, ["energy", "address", "address-validated", "energy-type", "gasMeterType"])
            ])
          ]),
          tenant: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(TenantDetailsPage, {
                "personal-info": tenantPersonalInfo.value,
                "onUpdate:personalInfo": _cache[4] || (_cache[4] = ($event: any) => ((tenantPersonalInfo).value = $event)),
                "telephone-number-valid": tenantTelephoneNumberValid.value,
                "onUpdate:telephoneNumberValid": _cache[5] || (_cache[5] = ($event: any) => ((tenantTelephoneNumberValid).value = $event))
              }, null, 8, ["personal-info", "telephone-number-valid"])
            ])
          ]),
          landlord: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(PropertyOwnerDetailsPage, {
                "landlord-details": landlordPersonalInfo.value,
                "onUpdate:landlordDetails": _cache[6] || (_cache[6] = ($event: any) => ((landlordPersonalInfo).value = $event)),
                validationGroup: "landlord",
                "telephone-number-valid": landlordTelephoneNumberValid.value,
                "onUpdate:telephoneNumberValid": _cache[7] || (_cache[7] = ($event: any) => ((landlordTelephoneNumberValid).value = $event)),
                title: "Landlord Details",
                "owner-label": "Landlord"
              }, null, 8, ["landlord-details", "telephone-number-valid"])
            ])
          ]),
          tcf: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(DocumentUpload, {
                onTcfChanged: onTcfChanged,
                onlyShowTcf: true,
                "max-file-size": 20000000
              }),
              (!tcf.value || (tcf.value && tcf.value.length == 0))
                ? (_openBlock(), _createBlock(TcfMessage, { key: 0 }))
                : _createCommentVNode("", true)
            ])
          ]),
          consent: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(ConsentPage, {
                modelValue: dateRegulationsConsent.value,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dateRegulationsConsent).value = $event)),
                validationGroup: "consent"
              }, null, 8, ["modelValue"])
            ])
          ]),
          "switch-summary": _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(SummaryPage, {
                energySelectedAddress: mprnAddress.value,
                landlordPersonalInfo: landlordPersonalInfo.value,
                tenantPersonalInfo: tenantPersonalInfo.value,
                energyType: energyDetails.value.energyType,
                tcfUploaded: !tcfUploaded.value,
                displayTcf: true,
                onUpdatePageNumber: updatePageNumber,
                disableEditButtons: disableSummaryEditButtons.value
              }, null, 8, ["energySelectedAddress", "landlordPersonalInfo", "tenantPersonalInfo", "energyType", "tcfUploaded", "disableEditButtons"])
            ])
          ]),
          confirmation: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["selected-index", "data-source"])
      ]),
      _createElementVNode("section", _hoisted_11, [
        _createElementVNode("div", {
          class: _normalizeClass(["left-button", {
            hideButton:
              selectedIndex.value == _unref(TenantSwitchStep).PropertyLookup ||
              selectedIndex.value == _unref(TenantSwitchStep).Confirmation,
          }])
        }, [
          _createVNode(_unref(DxButton), {
            text: "Back",
            onClick: _cache[10] || (_cache[10] = (e) => navigate(-1, e)),
            icon: "spinleft",
            disabled: backButtonDisabled.value
          }, null, 8, ["disabled"])
        ], 2),
        _createElementVNode("span", _hoisted_12, _toDisplayString(switchStage.value) + " of 8", 1),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: _normalizeClass(["new-switchover", {
              hideButton: selectedIndex.value < _unref(TenantSwitchStep).Confirmation,
            }])
          }, [
            _createVNode(_unref(DxButton), {
              text: "New Switch",
              onClick: newSwitchOver
            })
          ], 2),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_unref(DxButton), {
              text: nextSubmitButtonText.value,
              onClick: _cache[11] || (_cache[11] = (e) => navigate(1, e)),
              icon: "spinright",
              rtlEnabled: true,
              validationGroup: buttonValidationGroup.value,
              disabled: nextButtonLocked.value
            }, null, 8, ["text", "validationGroup", "disabled"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "width", "show-close-confirmation-prompt"]))
}
}

})